/* import __COLOCATED_TEMPLATE__ from './sla-delete-modal.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Component from '@glimmer/component';

export default class SlaDeleteModal extends Component {
  get title() {
    return `Delete "${this.args.sla?.name}"`;
  }
}
